let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("69Jsf")).then(() => parcelRequire('f0wJ8'));